import { FC, ReactElement } from 'react';
import { FormattedMessage } from 'react-intl';
import Constraints from 'src/shared-components/Constraints/Constraints';
import { DrugItem } from 'src/api/types';
import dynamic from 'next/dynamic';
import { GTAGPrefix } from 'src/hooks/useGTAG';
import useTopDrugsStore from 'src/hooks/useTopDrugsStore';
import trns from './trns';

const DesktopDrugList = dynamic(() => import('./DesktopDrugList'));
const MobileDrugList = dynamic(() => import('./MobileDrugList'));

interface Props {
  customLabel?: ReactElement;
  drugsList?: DrugItem[];
  gtagPrefix: GTAGPrefix;
  isLoading?: boolean;
  addToCartGAAction?: string;
  clickOnCardGAAction?: string;
}

const DrugsCarouselContainer: FC<Props> = ({
  customLabel,
  drugsList,
  gtagPrefix,
  isLoading: externalLoadingProp
}) => {
  const { isLoading, topDrugsList } = useTopDrugsStore();

  return (
    <div className="flex w-full relative">
      <Constraints className="flex w-full items-center justify-center">
        <div className="flex h-full items-center justify-center flex-col w-full">
          {customLabel || (
            <h2 className="uppercase text-astronautBlue fs-header4-bold text-center">
              <FormattedMessage {...trns.topSearchedDrugs} />
            </h2>
          )}
          <div className="hidden m:flex">
            <DesktopDrugList
              isLoading={externalLoadingProp || isLoading}
              drugsList={drugsList ?? topDrugsList}
              gtagPrefix={gtagPrefix}
            />
          </div>
          <div className="flex m:hidden">
            <MobileDrugList
              isLoading={externalLoadingProp || isLoading}
              drugsList={drugsList ?? topDrugsList}
              gtagPrefix={gtagPrefix}
            />
          </div>
        </div>
      </Constraints>
    </div>
  );
};

export default DrugsCarouselContainer;
